<template>
  <div>
    <h3 class="mt-6">Relais Résidentiels ({{ filteredRelays.length }})</h3>

    <v-row>
      <v-col>
        <v-select
          hide-details
          clearable
          :items="formChoicesCountry"
          label="Tous les pays"
          v-model="form.fields.country">
        </v-select>
      </v-col>
      <v-col>
        <v-select
          hide-details
          clearable
          :items="form.choices.status"
          label="Tous les status"
          v-model="form.fields.status">
        </v-select>
      </v-col>
      <v-col>
        <v-select
          hide-details
          clearable
          :items="formChoicesVersion"
          label="Toutes les versions"
          v-model="form.fields.version">
        </v-select>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col style="text-align: center" class="col-sm-2 col-md-1" v-for="relay in filteredRelays"
             :key="'mobile-relay-' + relay.id">
        <div style="margin: 2px;" class="grey lighten-4">
          <v-badge dot :color="relay.latency < 100 ? 'success' : 'error'" overlap>
            <v-icon v-if="isRelayAvailable(relay)" color="success">mdi-check-network</v-icon>
            <v-icon v-else-if="isRelayThrottled(relay)" color="grey">mdi-check-network-outline</v-icon>
            <v-icon v-else-if="isRelayBanned(relay)" color="error">mdi-close-network-outline</v-icon>
            <v-icon v-else color="grey">mdi-check-network-outline</v-icon>
          </v-badge>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'RouterResidentialRelays',
  props: ['telemetry'],
  data () {
    return {
      form: {
        fields: {
          country: null,
          status: null,
          version: null,
        },
        choices: {
          country: [],
          status: ['Disponible', 'En attente', 'Banni']
        },
      }
    }
  },
  methods: {
    isRelayAvailable (relay) {
      return typeof (relay.targetThrottle[0]) === 'undefined'
    },
    isRelayThrottled (relay) {
      const throttleDate = (new Date()).setMinutes((new Date()).getMinutes() + 2)
      return typeof (relay.targetThrottle[0]) !== 'undefined' && relay.targetThrottle[0] < throttleDate
    },
    isRelayBanned (relay) {
      const throttleDate = (new Date()).setMinutes((new Date()).getMinutes() + 2)
      return typeof (relay.targetThrottle[0]) !== 'undefined' && relay.targetThrottle[0] > throttleDate
    }
  },
  computed: {
    relays () {
      try {
        return this.telemetry.transport['residential-relay']
      } catch (e) {
        return []
      }
    },
    filteredRelays () {
      const fields = this.form.fields
      let relays = this.relays

      if (fields.country) {
        relays = relays.filter(relay => relay.meta.country_name === fields.country)
      }

      if (fields.version) {
        relays = relays.filter(relay => relay.version === fields.version)
      }

      if (fields.status) {
        if (fields.status === 'Disponible') relays = relays.filter(relay => this.isRelayAvailable(relay))
        else if (fields.status === 'En attente') relays = relays.filter(relay => this.isRelayThrottled(relay))
        else if (fields.status === 'Banni') relays = relays.filter(relay => this.isRelayBanned(relay))
      }

      return relays
    },
    formChoicesCountry () {
      return [...new Set(this.relays.map(relay => relay.meta.country_name))]
    },
    formChoicesVersion () {
      return [...new Set(this.relays.map(relay => relay.version))]
    },
  }
}
</script>